<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="crewMemberTypeAudits && crewMemberTypeAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="crewMemberTypeAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Crew Member Type audits </ng-template>
</ng-template>
